// B2 - Final Sınavı
// Kapsamlı final sınavı - Tüm B2 konuları (Ünite sınavlarından FARKLI sorular)

export const B2_FINAL = {
  'B2-FINAL': {
    id: 'B2-FINAL',
    title: 'B2 Final Sınavı',
    type: 'exam',
    exercises: [
      // UNIT 1: Present Perfect (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'She _____ as a flight attendant since 2019.',
        options: ['has worked', 'have worked', 'worked', 'works'],
        correct: 'has worked',
        explanation: 'She + has + V3 (Present Perfect)'
      },
      {
        type: 'multipleChoice',
        question: 'They _____ already finished the safety demonstration.',
        options: ['have', 'has', 'had', 'having'],
        correct: 'have',
        explanation: 'They + have (çoğul) + already + V3'
      },
      {
        type: 'multipleChoice',
        question: 'How long _____ you worked in customer service?',
        options: ['have', 'has', 'did', 'do'],
        correct: 'have',
        explanation: 'How long + have + you + V3'
      },
      
      // UNIT 2: Past Continuous (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'The passengers _____ boarding when the announcement came.',
        options: ['were', 'was', 'are', 'is'],
        correct: 'were',
        explanation: 'The passengers (çoğul) + were + V-ing'
      },
      {
        type: 'multipleChoice',
        question: 'What _____ you doing at 3 PM yesterday?',
        options: ['were', 'was', 'did', 'are'],
        correct: 'were',
        explanation: 'What were you doing (Past Continuous soru)'
      },
      
      // UNIT 3: Second Conditional (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'If I _____ the captain, I would make an announcement.',
        options: ['were', 'am', 'was', 'be'],
        correct: 'were',
        explanation: 'If I were... (Second Conditional)'
      },
      {
        type: 'multipleChoice',
        question: 'What _____ you do if a passenger refused to sit down?',
        options: ['would', 'will', 'do', 'did'],
        correct: 'would',
        explanation: 'Second Conditional: What would you do if...'
      },
      
      // UNIT 4: Passive Voice (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'The emergency exits _____ located over the wings.',
        options: ['are', 'is', 'be', 'been'],
        correct: 'are',
        explanation: 'Present Passive: are + located'
      },
      {
        type: 'multipleChoice',
        question: 'The luggage _____ checked before departure.',
        options: ['was', 'were', 'is', 'be'],
        correct: 'was',
        explanation: 'Past Passive: was + V3 (luggage tekil)'
      },
      {
        type: 'multipleChoice',
        question: 'Electronic devices _____ be switched off during takeoff.',
        options: ['must', 'must be', 'must to', 'must been'],
        correct: 'must',
        explanation: 'Modal + be + V3: must be switched off'
      },
      
      // UNIT 5: Reported Speech (FARKLI SORULAR)
      {
        type: 'multipleChoice',
        question: 'The passenger _____ me he needed assistance.',
        options: ['told', 'said', 'tell', 'say'],
        correct: 'told',
        explanation: 'told + me (kişi var) = told'
      },
      {
        type: 'multipleChoice',
        question: '"I am feeling sick." → She said she _____ feeling sick.',
        options: ['was', 'is', 'were', 'be'],
        correct: 'was',
        explanation: 'Reported Speech: am → was'
      },
      {
        type: 'multipleChoice',
        question: '"Please remain seated." → The captain asked us _____ seated.',
        options: ['to remain', 'remain', 'remaining', 'remained'],
        correct: 'to remain',
        explanation: 'Command → asked + to + verb'
      },
      {
        type: 'multipleChoice',
        question: '"Can I have some water?" → He asked if he _____ have some water.',
        options: ['could', 'can', 'would', 'may'],
        correct: 'could',
        explanation: 'Reported Speech: can → could'
      },
      
      // MIXED EXERCISES
      {
        type: 'fillInBlank',
        sentence: 'The crew _____ (work) for Emirates for 10 years.',
        answer: 'has worked',
        hint: 'Present Perfect: has + V3'
      },
      {
        type: 'fillInBlank',
        sentence: 'If there _____ (be) turbulence, I would secure the galley.',
        answer: 'were',
        hint: 'Second Conditional: If + Past'
      },
      {
        type: 'matchPairs',
        instruction: 'Doğru zaman eşleştirmesi yapın',
        pairs: [
          { left: 'since 2020', right: 'Present Perfect' },
          { left: 'at 5 PM yesterday', right: 'Past Continuous' },
          { left: 'If I had money', right: 'Second Conditional' },
          { left: 'was served', right: 'Past Passive' }
        ]
      },
      {
        type: 'matchPairs',
        instruction: 'Reported Speech dönüşümlerini eşleştirin',
        pairs: [
          { left: '"I am tired"', right: 'She said she was tired' },
          { left: '"I will help"', right: 'He said he would help' },
          { left: '"Please sit down"', right: 'She asked me to sit down' },
          { left: '"Can you help?"', right: 'He asked if I could help' }
        ]
      }
    ]
  }
};

export default B2_FINAL;
